import { Button } from "@mui/material"

interface SubmitButtonProps {
    label: string
}

export const SubmitButton = (props: SubmitButtonProps) => {
    return (
        <Button
          type="submit"
          variant="contained"
          color="primary"
          sx={{
            width: "8rem",
            fontWeight: "bold",
            height: "2.5rem",
            textTransform: "none",
            marginTop: "1rem",
            display: "block",
            backgroundColor: "var(--gradientStart)",
            "&:hover": {
              backgroundColor: "var(--gradientMiddle)",
            },
          }}
        >
          {props.label}
        </Button>
    )
}
